import script from "./UserEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEdit.vue?vue&type=script&setup=true&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=1ae1f8c3&lang=less"

const __exports__ = script;

export default __exports__